import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { setQuotationParams } from "../../actions/searchActions";

import Frame from "../../lib/sp_frame";

import { formatURL, changeTitle, isB2b, buildSearchWithDestinationCategories } from "../../utils";
import dataLayer from "../../utils/dataLayer";

const addClass = (el, className) => {
  el.classList.add(className);
};

const rmClass = (el, className) => {
  el.classList.remove(className);
};

const addAttr = (el, attrName, attrValue) => {
  el.setAttribute(attrName, attrValue);
};

const rmAttr = (el, attrName) => {
  el.removeAttribute(attrName);
};

const init = (component) => {
  const destinationInput = document.querySelector("#destinationSp");
  const departureDateInput = document.querySelector("#departureDateInput");
  const departureDateContainer = document.querySelector("#departureDateContainer");
  const returningDateInput = document.querySelector("#returningDateInput");
  const returningDateContainer = document.querySelector("#returningDateContainer");

  const destination = new Frame.Destination({
    input: destinationInput,
    onError: {
      INVALID_VALUE: () => {
        addClass(destinationInput, "is-danger");
      },
    },
    onChange: () => {
      rmClass(destinationInput, "is-danger");
      component.handleChange({ target: { name: "destination", value: destination.getSelected().slug } });
    },
  });

  const departureDate = new Frame.Period({
    input: departureDateInput,
    dateContainer: departureDateContainer,
    container: document.getElementById("ex-input-departure"),
    multipleCalendars: true,
    startDatePicker: true,
    onShow: (_, drop) => {
      addClass(departureDateContainer, "ex-inputs-picker-visible");
      if (drop === "up") {
        addClass(departureDateContainer, "ex-inputs-picker-up");
      } else {
        rmClass(departureDateContainer, "ex-inputs-picker-up");
      }
      if (window.innerWidth <= 640) {
        addClass(document.querySelector("html"), "overflow-hidden");
        addClass(document.querySelector("body"), "overflow-hidden");
      }
    },
    onChange: () => {
      rmClass(departureDateInput, "is-danger");
    },
    onError: {
      INVALID_VALUE: () => {
        addClass(departureDateInput, "is-danger");
      },
    },
    onHide: () => {
      if (window.innerWidth <= 640) {
        rmClass(document.querySelector("html"), "overflow-hidden");
        rmClass(document.querySelector("body"), "overflow-hidden");
      }
      rmClass(departureDateContainer, "ex-inputs-picker-visible");
      rmClass(departureDateContainer, "ex-inputs-picker-up");
    },
    onSelect: (frame) => {
      if (frame.departureDate.datePicker.state.start) {
        component.handleChange({ target: { name: "begin_date", value: frame.departureDate.datePicker.state.start.toPtBr() } });
        departureDateInput.value = frame.departureDate.datePicker.state.start.toPtBr();
      }
    },
  });

  const returningDate = new Frame.Period({
    input: returningDateInput,
    dateContainer: returningDateContainer,
    container: document.getElementById("ex-input-return"),
    multipleCalendars: true,
    startDatePicker: false,
    onShow: (_, drop) => {
      if (window.innerWidth <= 640) {
        addClass(document.querySelector("html"), "overflow-hidden");
        addClass(document.querySelector("body"), "overflow-hidden");
      }
      addClass(returningDateContainer, "ex-inputs-picker-visible");
      if (drop === "up") {
        addClass(returningDateContainer, "ex-inputs-picker-up");
      } else {
        rmClass(returningDateContainer, "ex-inputs-picker-up");
      }
    },
    onChange: () => {
      rmClass(returningDateInput, "is-danger");
    },
    onError: {
      INVALID_VALUE: () => {
        addClass(returningDateInput, "is-danger");
      },
    },
    onHide: () => {
      if (window.innerWidth <= 640) {
        rmClass(document.querySelector("html"), "overflow-hidden");
        rmClass(document.querySelector("body"), "overflow-hidden");
      }
      rmClass(returningDateContainer, "ex-inputs-picker-visible");
      rmClass(returningDateContainer, "ex-inputs-picker-up");
    },
    onDisable: () => {
      addAttr(returningDateInput, "disabled", "disabled");
    },
    onEnable: () => {
      rmAttr(returningDateInput, "disabled");
    },
    onSelect: (frame) => {
      if (frame.returningDate.datePicker.state.end) {
        component.handleChange({ target: { name: "end_date", value: frame.returningDate.datePicker.state.end.toPtBr() } });
        returningDateInput.value = frame.returningDate.datePicker.state.end.toPtBr();
      }
    },
  });

  Frame.Frame({
    destination,
    departureDate,
    returningDate,
    client: false,
    openInNewTab: false,
    trigger: document.getElementById("searchTriggerInput"),
    onSuccess: () => {},
  });
};

class SearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = { destination: "brasil", begin_date: "", end_date: "" };
    this.handleChange = this.handleChange.bind(this);
    this.searchPlan = this.searchPlan.bind(this);
    this.setQuotationParams = this.props.setQuotationParams.bind(this);
    this.init = init;
  }

  componentDidMount() {
    this.init(this);
    dataLayer.pageView('home');
  }

  searchPlan() {
    dataLayer.raw({ event: 'page_resultados_busca' });

    let basePath = "/pesquisa";
    if (isB2b()) basePath = "/pesquisa-b2b";

    const search = buildSearchWithDestinationCategories(this.props.destinations, this.state.destination);
    const path = formatURL(
      this.props.match.params,
      `${basePath}/${this.state.destination}/${this.state.begin_date}/${this.state.end_date}`,
      search,
      !search
    );
    this.props.history.push(path);
  }

  handleChange(e) {
    if (e.target.name === "begin_date" || e.target.name === "end_date") {
      const spl_date = e.target.value.split("/");
      const val = `${spl_date[2]}-${spl_date[1]}-${spl_date[0]}`;
      e.target.value = val;

    }
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    return (
      <div className="form_v1">
        <div className="line01">
          <div htmlFor="continente" className="input_container is-grouped location" id="destinationSpDiv">
            <img className="location-signal" src="https://www.segurospromo.com.br/images/home/point_destino.svg" alt="" />
            <input id="destinationSp" aria-label="continente" readOnly type="text" placeholder="Continente ou país de destino" />
            <img
              className="danger-signal is-stealth"
              item="destination"
              src="https://www.segurospromo.com.br/images/home/alert_vermelho.svg"
              alt=""
              data-cy="search-frame-destino"
            />
            <img className="arrowmenu" src="https://www.segurospromo.com.br/images/home/arrow_down.svg" alt="" />
          </div>
          <div htmlFor="partida" className="input_container is-grouped partida ex-inputs" id="ex-input-departure">
            <img src="https://www.segurospromo.com.br/images/home/partida.svg" alt="" />
            <input
              aria-label="partida"
              type="text"
              name="departureDate"
              placeholder="Partida"
              id="departureDateInput"
              readOnly
              data-cy="search-frame-partida"
            />
            <img
              className="danger-signal is-stealth"
              item="departureDate"
              src="https://www.segurospromo.com.br/images/home/alert_vermelho.svg"
              alt=""
            />
            <div id="departureDateContainer" className="ex-inputs-picker" />
          </div>
          <div htmlFor="retorno" className="input_container is-grouped retorno ex-inputs" id="ex-input-return">
            <img src="https://www.segurospromo.com.br/images/home/retorno.svg" alt="" />
            <input
              aria-label="retorno"
              type="text"
              name="Retorno"
              placeholder="Retorno"
              id="returningDateInput"
              readOnly
              data-cy="search-frame-retorno"
            />
            <img
              className="danger-signal is-stealth"
              item="returningDate"
              src="https://www.segurospromo.com.br/images/home/alert_vermelho.svg"
              alt=""
            />
            <div id="returningDateContainer" className="ex-inputs-picker" />
          </div>
          <button aria-label="pesquisar" className="btnf-pesquisar" id="searchTriggerInput" onClick={this.searchPlan}>
            Pesquisar
          </button>
        </div>
        <div className="line02 is-stealth" id="subscriberForm" style={{ display: "none" }}>
          <div htmlFor="nome" className="input_container nome" id="inputNameDiv">
            <img src="https://www.segurospromo.com.br/images/home/nome.svg" alt="" />
            <input aria-label="nome" type="text" placeholder="Nome" name="spName" id="nameSp" data-cy="search-frame-nome" />
            <img className="danger-signal is-stealth" item="name" src="https://www.segurospromo.com.br/images/home/alert_vermelho.svg" alt="" />
          </div>
          <div htmlFor="email" className="input_container email" id="inputEmailDiv">
            <img src="https://www.segurospromo.com.br/images/home/email.svg" alt="" />
            <input aria-label="email" name="spEmail" type="email" id="emailSp" placeholder="E-mail" data-cy="search-frame-email" />
            <img className="danger-signal is-stealth" item="email" src="https://www.segurospromo.com.br/images/home/alert_vermelho.svg" alt="" />
          </div>
          <div htmlFor="celular" className="input_container celular" id="inputCellphoneDiv">
            <img src="https://www.segurospromo.com.br/images/home/celular_novo_2.svg" alt="" />
            <input aria-label="celular" name="spCellphone" type="tel" id="cellphoneSp" placeholder="Celular" data-cy="search-frame-celular" />
            <img className="danger-signal is-stealth" item="cellphone" src="https://www.segurospromo.com.br/images/home/alert_vermelho.svg" alt="" />
          </div>
          <button aria-label="pesquisar" className="btnf-pesquisar" id="showSubscriber" data-cy="search-frame-pesquisar">
            Pesquisar
          </button>
        </div>
      </div>
    );
  }
}

class Home extends Component {
  constructor(props) {
    super(props);

    changeTitle("home");
  }
  render() {
    return (
      <div className="comp_frame_v1">
        <div className="component">
          <div className="form_contents">
            <SearchBar setQuotationParams={setQuotationParams} match={this.props.match} history={this.props.history} destinations={this.props.destinations} />
          </div>
          <div className="contact_contents">
            <div className="bbox_phone">
              <div className="box_phone">
                <img src="https://www.segurospromo.com.br/shared/images/home/televendas_novo.svg" alt="" />
                <span>TELEVENDAS:</span>
                <strong>31 4003-8442</strong>
              </div>
              {/* <div className="box_phone">
                                <img src="https://www.segurospromo.com.br/shared/images/home/whatsapp_atendimento.svg" alt="" width="22px" height="22px" />
                                <span>WHATSAPP:</span>
                                <strong>31 98348-7670</strong>
                            </div> */}
            </div>
            <div className="open_days">
              <span>
                <strong>Seg a Sex:</strong> 08h às 20h
              </span>
              <span>
                <strong>Sábados, Domingos e feriados:</strong> 10h às 16h
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect((state) => ({ destinations: state.global.destinations }), {
    setQuotationParams,
  })(Home)
);



// WEBPACK FOOTER //
// ./src/views/home/Home.jsx